<template>
  <div>
    <nav-bar-component />
  </div>
  <div class="wrapper col-sm-6 col-md-11 mx-auto pt-5">
    <div class="row mx-auto">
      <div class="col-lg-8 col-md-7 col-sm-12">
        <div class="col-md-12 col-sx-12">
          <div class="col col-md-12 col-sx-6 pb-5">
            <h1 class="fw-bold mb-0">Dados do sistema</h1>
            <p class="subtitle mt-3 mb-0 fw-bold"><strong>{{ customer?.subscription?.sale_item.name }}</strong></p>
          </div>

          <div class="row mt-4">
            <div class="col col-md-6 col-sx-6">
              <span class="information-label">Razão Social do Cliente</span>
              <br />
              <span class="information-value">{{ customer.legal_name }}</span>
            </div>

            <div class="col col-md-6 col-sx-6">
              <span class="information-label">CNPJ do Cliente</span>
              <br />
              <span class="information-value">{{
                this.customer.document
              }}</span>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col col-md-6 col-sx-6">
              <span class="information-label">Nome Fantasia</span>
              <br />
              <span class="information-value">{{ customer.name }}</span>
              <br />
            </div>

            <div class="col col-md-6 col-sx-6 h6">
              <span class="information-label">Telefone/Whatsapp do Representente legal</span>
              <br />
              <span class="information-value">{{ this.address.phone }}</span>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col col-md-12 col-sx-12">
              <span class="information-label">E-mail do Cliente</span>
              <br />
              <span class="information-value">{{ this.customer.email }}</span>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col col-md-12 col-sx-12">
              <span class="information-label">Telefone/Celular do Cliente</span>
              <br />
              <span class="information-value">{{ this.customer.mobile }}</span>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col col-md-6 col-sx-6 h6">
              <span class="information-label">Cidade</span>
              <br />
              <span class="information-value">{{ this.address.city }}</span>
            </div>

            <div class="col col-md-6 col-sx-6 h6">
              <span class="information-label">Estado</span>
              <br />
              <span class="information-value">{{ this.address.state }}</span>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col col-md-6 col-sx-6">
              <span class="information-label">CEP</span>
              <br />
              <span class="information-value">{{ address.zip_code }}</span>
            </div>

            <div class="col col-md-6 col-sx-6 h6">
              <span class="information-label">Bairro</span>
              <br />
              <span class="information-value">{{ this.address.district }}</span>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col col-md-6 col-sx-6">
              <span class="information-label">Número</span>
              <br />
              <span class="information-value">{{ address.number }}</span>
            </div>

            <div class="col col-md-6 col-sx-6">
              <span class="information-label">Endereço</span>
              <br />
              <span class="information-value">{{ address.street }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Inicio do Dados do plano -->
      <div class="col-lg-4 col-md-5 col-sm-12 checkout-wrapper mx-auto">
        <div class="row-12">
          <h2 class="fw-bold">Dados do plano</h2>
        </div>
        <div class="row-12">
          <div class="row mt-3">
            <div class="col col-md-4 col-sm-6">
              <span class="fw-bold checkout-label">Produto</span>
            </div>
            <div class="col col-md-8 col-sm-6">
              <p class="checkout-primary-value">
                {{ typePlan }}
              </p>
            </div>
          </div>

          <div class="row mt-2" v-show="disableCount">
            <div class="col col-md-6 col-sx-6">
              <span class="fw-bold checkout-label">Quantidade de clientes por mês</span>
            </div>
            <div class="col col-md-6 col-sx-6">
              <p class="checkout-primary-value">
                {{ quantityMensagePlans }}
              </p>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col col-md-6 col-sx-6">
              <span class="fw-bold checkout-label">Usuários inclusos</span>
            </div>
            <div class="col col-md-6 col-sx-6">
              <p class="checkout-primary-value" id="licenses">{{ licensesPlans }}</p>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col col-md-6 col-sx-6">
              <span class="fw-bold checkout-label">Recorrência de pagamento</span>
            </div>
            <div class="col col-md-6 col-sx-6">
              <p class="checkout-primary-value">
                {{ yearOrMonth }}
              </p>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col col-md-6 col-sx-6">
              <span class="fw-bold checkout-label">Quantidade de licenças</span>
            </div>
            <div class="col col-md-6 col-sx-6">
              <p class="checkout-primary-value">1</p>
            </div>
          </div>

          <!-- Desconto nos planos -->
          <div class="row mt-2" v-show="enableDiscount">
            <div class="col col-md-6 col-sx-6">
              <span class="fw-bold checkout-label">Desconto</span>
            </div>
            <div class="col col-md-6 col-sx-6 text-secondary">
              <p class="checkout-primary-value">{{ percentageCoupon }} %</p>
            </div>
          </div>

          <!--Valor anual-->
          <div class="row mt-2" v-show="!disableTag">
            <p class="checkout-price">
              R$
              <span class="checkout-price-value">
                {{ yearOrMonth === 'Anual'
                    ? formatBRLWithoutRS(valuePlans)
                    : formatBRLWithoutRS(total_value_month)
                }}
              </span>
              <span v-if="yearOrMonth === 'Anual'"> ao ano</span>
              <span v-else> ao mês</span>
            </p>
          </div>


          <!--Valor mensal-->
          <div class="row mt-2" v-show="disableTag">
            <p class="checkout-price">
              R$ <span class="checkout-price-value">{{ formatBRLWithoutRS(total_value_month) }}</span> ao mês
            </p>
          </div>
        </div>

        <div class="row-12 mt-5" v-show="usersEnable">
          <div class="row">
            <h2 class="fw-bold">Usuários</h2>
          </div>

          <div class="row mt-2">
            <div class="col col-md-6 col-sx-6">
              <span class="fw-bold checkout-label">Usuários extras</span>
            </div>
            <div class="col col-md-6 col-sx-6">
              <p class="checkout-value">{{ extraUsers }}</p>
            </div>
          </div>

          <div class="row mt-2" v-if="yearOrMonth === 'Anual'">
            <div class="col col-md-6 col-sx-6">
              <span class="fw-bold checkout-label">Valor anual</span>
            </div>
            <div class="col col-md-6 col-sx-6">
              <p class="checkout-value">{{ userAddonValue }}</p>
            </div>
          </div>

          <!--Desconto dos usuários -->
          <div class="row mt-2" v-show="hasUsersDiscount">
            <div class="col col-md-6 col-sx-6">
              <span class="fw-bold checkout-label">Desconto</span>
            </div>
            <div class="col col-md-6 col-sx-6">
              <p class="checkout-value">{{ userDiscount }} %</p>
            </div>
          </div>
          
          <div class="row mt-2">
            <p class="checkout-price">
              R$ <span class="checkout-price-value">{{ formatBRLWithoutRS(usersValue) }}</span> ao mês
            </p>
          </div>
        </div>

          <!--Integração de chip-->
        <div class="row-12 mt-5" v-show="chipEnable">
          <div class="row">
            <h2 class="fw-bold">Chips Adicionais</h2>
          </div>

          <div class="row mt-2">
            <div class="col-4">
              <span class="fw-bold checkout-label">Quantidade</span>
            </div>
            <div class="col-8">
              <p class="checkout-value">{{ chipName }}</p>
            </div>
          </div>

          <div class="row mt-2" v-if="yearOrMonth === 'Anual'">
            <div class="col col-md-6 col-sx-6">
              <span class="fw-bold checkout-label">Valor anual</span>
            </div>
            <div class="col col-md-6 col-sx-6">
              <p class="checkout-value">{{ formatBRL(chipsValueUnit * 12) }}</p>
            </div>
          </div>

          <!--Desconto dos chips -->
          <div class="row mt-2" v-show="chipCouponEnable">
            <div class="col col-md-6 col-sx-6">
              <span class="fw-bold checkout-label">Desconto</span>
            </div>
            <div class="col col-md-6 col-sx-6">
              <p class="checkout-value">{{ chipDiscount }} %</p>
            </div>
          </div>

          <div class="row mt-2">
            <p class="checkout-price">
              R$ <span class="checkout-price-value">{{ formatBRLWithoutRS(chipsMonthlyValue) }}</span> ao mês
            </p>
          </div>
        </div>
        
        <div class="row-12 mt-5" v-if="oneTimeCredit > 0">
          <div class="row">
            <h2 class="fw-bold">Mensageria</h2>
          </div>

          <div class="row mt-2">
            <div class="col col-md-6 col-sx-6">
              <span class="fw-bold checkout-label">Crédito avulso</span>
            </div>
            <div class="col col-md-6 col-sx-6">
              <p class="checkout-value">{{ formatBRL(oneTimeCredit) }}</p>
            </div>
          </div>

          <div class="row mt-2">
            <p class="checkout-price">
              R$ <span class="checkout-price-value">{{ formatBRLWithoutRS(oneTimeCredit) }}</span> pagamento único
            </p>
          </div>
        </div>

        <div class="row-12 mt-5" >
          <div class="row">
            <h2 class="fw-bold">Serviços</h2>
          </div>

          <div class="row mt-3">
            <p class="checkout-value text-start">
              Os custos de implantação serão cobrados apenas <strong>uma vez</strong>.
            </p>
          </div>
          
          <div class="row mt-2" v-if="hasImplementation">
            <div class="col col-md-6 col-sx-6">
              <span class="fw-bold checkout-label">Implantação</span>
            </div>
            <div class="col col-md-6 col-sx-6">
              <p class="checkout-value">{{ formatBRL(implantacaoValueUnit) }}</p>
            </div>
          </div>

          <div class="row mt-2" v-if="hasImplementationTec">
            <div class="col col-md-6 col-sx-6 h6">
              <span class="fw-bold checkout-label">Implantação Técnica</span>
            </div>
            <div class="col col-md-6 col-sx-6 text-secondary text-end">
              <p class="checkout-value">{{ formatBRL(implantacaoTecValueUnit) }}</p>
            </div>
          </div>

          <div class="row mt-2" v-show="descountDisabled">
            <div class="col col-md-6 col-sx-6 h6">
              <span class="fw-bold checkout-label">Desconto</span>
            </div>
            <div class="col col-md-6 col-sx-6 text-secondary text-end">
              <p class="checkout-value">{{ implementacaoDiscount }} %</p>
            </div>
          </div>

          <div class="row mt-2">
            <p class="checkout-price">
              R$ <span class="checkout-price-value">{{ formatBRLWithoutRS(totalValueService) }}</span> pagamento único
            </p>
          </div>
        </div>

        <div class="row-12 purchase-summary mt-5">
          <div class="row">
            <h2 class="fw-bold purchase-summary-title">Resumo de compra</h2>
          </div>

          <div class="row mt-2">
            <div class="col col-md-6 col-sx-6">
              <span class="fw-bold checkout-label">Investimento total</span>
            </div>
            <div class="col col-md-6 col-sx-6">
              <p class="checkout-primary-value">
                R$ 
                <span class="checkout-primary-price-value">
                  {{ totalPriceComputed }}
                </span>
              </p>
            </div>
          </div>
        </div>

        <div class="row-12 mt-5">
          <div>
            <input
              class="form-check-input" 
              type="checkbox"
              id="flexCheckDefault"
              :disabled="this.checketFinish"
              @click="termsAccepted"
            />
            <label class="text-term" for="flexCheckDefault">
              &nbsp;<strong class="text-danger">*</strong>Li e Concordo com os termos da RD Station Conversas.
              <a :href="ulrBaseTermo" target="_blank">
                <strong>Ver PDF</strong>
              </a>
            </label>
          </div>
        </div>

        <div class="row-12 mt-5">
          <div class="d-flex flex-column gap-3 justify-content-center align-items-center">
            <button
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#buttonCancel"
              class="btn button-back text-secondary"
              :disabled="cancel"
              id="buttonDeclined"
            >
               <strong>Cancelar proposta</strong>
            </button>

            <button
              class="btn button-finish"
              id="buttonAccepted"
              type="button"
              data-bs-toggle="modal"
              @click="nextContract"
              :data-bs-target="nextContractTarget"
              :disabled="activateButton"
            >
              Prosseguir para pagamento
            </button>
          </div>
        </div>
        <modal-proposal-accepted 
        @proposal-accepted="createProposal()"
        :isLoading="isLoading"        
        />
        <modal-cancel-proposal @cancel-proposal="cancelProposal()"/>     
        <modal-alert-default
        :status="'proposalCreated'"
        :title="modalTitle"
        :message="modalMessage"
      />
        <modal-alert-default
        :status="'proposalCanceled'"
        :title="modalTitle"
        :message="modalMessage"
        />
      </div>
    </div>
    <div class="row">
      <div class="col p-4">
        <footer-tallos-informations />
      </div>

    </div>
  </div>
</template>

<script>
import ModalAlertDefault from "@/components/Modal/ModalAlertDefault.vue";
import ModalCancelProposal from "@/components/Modal/ModalCancelProposal.vue";
import axios from "axios";
import { mapActions } from "vuex";
import { billingApiUrl } from "@/config/runtime-config";

export default {
  components: {
    ModalCancelProposal,
    ModalAlertDefault
  },
  data() {
    return {
      modalTitle: "",
      modalMessage: "",
      params: {},
      customer: {},
      address: {},
      contact: {},
      subscriptios: {},
      planTitle: "",
      proposal: {},
      cancel: false,
      activateButton: true,
      checketFinish: false,
      plansType: "",
      seatNumbers: "",
      value: "",
      priceMonth: "",
      priceYear: "",
      totalValue: "",
      descount: "",
      descountValue: "",
      priceTotalPlan: "",
      percentageCoupon: "",
      licenses: 0,
      yearOrMonth: "",
      expirationDay: "",
      disableTag: true,
      paymentsNetTermDays: "",
      addons: [],
      hasMessage: false,
      hasChip: false,
      hasImplementation: false,
      hasImplementationTec: false,
      packageValues: {} || 0,
      packageChipValues: {},
      technicalImplementationTec: {},
      technicalImplementation: {},
      totalValuePackage: "",
      totalValueService: 0,
      isLoading: false,
      valuePlans: 0,
      enableDiscount: false,
      priceMonthPerYear: "",
      descountDisabled: false,
      couponAddonPercentage: "",
      extraUsers: "",
      internalExternal: "",
      quantityMensagePlans: "",
      usersValue: 0,
      disableCount: false,
      discountPlan: "",
      usersEnable: false,
      userCouponEnable: false,
      usersValueUnit: "",
      userDiscount: "",
      typePlan: "",
      chipsValueUnit: 0,
      chipEnable: "",
      implantacaoValueUnit: "",
      implantacaoTecValueUnit: "",
      chipName: "",
      chipDiscount: "",
      chipCouponEnable: "",
      implamentationDiscount: false,
      hasUsersDiscount: false,
      nextContractTarget: "",
      totalValueChips: "",
      focal_point_data: {},
      ulrBaseTermo: "https://legal.rdstation.com/pt/rdc-services-agreement/",
      oneTimeCredit: 0,
      total_value_month: 0
    };
  },

  created() {
    this.updateTitle();
  },

  watch: {
    $route() {
      this.updateTitle();
    },
  },
  mounted() {
    this.params = this.$route.params.data;
    this.getCustumerById();
  },

  methods: {
    ...mapActions(['updateAccepted']),
    handleProposalAccepted() {
     this.updateAccepted(true)
    },
    updateTitle() {
      const pageTitle = this.$route.meta.title || "Título padrão";
      document.title = pageTitle;
    },

    iAcceptTerm() {
      this.termAcceptance = !this.termAcceptance;
    },

    formatBRLWithoutRS(valor) {
      const formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor).replaceAll("R$", "").trim();
    },

    formatBRL(valor) {
      const formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },

    cancelProposal() {
      let cancel = JSON.stringify({
        id: this.params,
        proposal_status: "proposal_cancelled",
      });

      let config = {
        method: "patch",
        maxBodyLength: Infinity,
        url: `${billingApiUrl()}proposal`,
        headers: {
          "Content-Type": "application/json",
        },
        data: cancel,
      };
      axios
        .request(config)
        .then(() => {
          this.cancel = true;
        })
        .catch((error) => {
          console.error(error);
        })
    },

    //Dados dos Clientes
    async getCustumerById() {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${billingApiUrl()}proposal/${this.params}`,
        headers: {},
      };
      await axios
        .request(config)
        .then((response) => {
          this.focal_point_data = response.data.extraDatas;
          const propsPlansName = response.data.subscription.sale_item.id.split(
            "-",
            5
          );
          this.proposalStatus = response.data.proposal_status;
          if (this.proposalStatus === "proposal_sent") {
            this.nextContractTarget = ".nextContract";
          }
          else if (this.proposalStatus === "proposal_cancelled") {
            this.nextContractTarget = ".proposalCanceled";
            this.modalTitle = 'Verificamos que esta proposta foi cancelada.'
            this.modalMessage = 'Por favor, entre em contato com o seu consultor e verifique o motivo do cancelamento.'
            
          }
          if (this.proposalStatus === "account_created" || this.proposalStatus === "payment_completed") {
            this.nextContractTarget = ".proposalCreated";
            this.modalTitle ="Verificamos que esta proposta já foi aceita!"
            this.modalMessage="Por favor, verifique o link de pagamento que foi enviado para o seu e-mail."
          }
          const propsPlansNumber = parseInt(propsPlansName[2]);

          //Quantidade de mensagens
          if (propsPlansNumber > 0) {
            this.disableCount = true;
            const multiplicadorMessange = 1000;
            this.quantityMensagePlans =
              propsPlansName[2] * multiplicadorMessange;
          }
          this.propsPlans = response.data.subscription.sale_item.id;
          const propsPlans = this.propsPlans;

          this.propsCoupons = response.data.subscription.coupon.id;

          const propsCoupons = this.propsCoupons;

          this.enableDiscount = false;

          //Verifica se existe o cupom para os Planos
          if (this.propsCoupons) {
            this.getCouponsPlans(propsPlans, propsCoupons);
          }
          this.oneTimeCredit = response.data?.one_time_credit
            ? response.data?.one_time_credit
            : 0;
          this.expirationDay =
            response.data.subscription.payment_config.expiration_day;
          this.paymentsNetTermDays =
            response.data.subscription.payment_config.payments_net_term_days;
          this.address = response.data.address;
          this.customer = response.data;
          this.subscriptios = response.data.subscription;
          this.addons = response.data.subscription.addons;
          this.plansType = this.subscriptios.sale_item.id;
          this.proposal = response.data;
          this.yearOrMonth =
            response.data.subscription.billing_config.quantity === 1
              ? "Mensal"
              : "Anual";
          if (this.yearOrMonth === "Anual") {
            this.disableTag = false;
          } else {
            this.disableTag = true;
          }

          //Chama função se tiver addons
          if (this.addons) {
            this.hasAddons();
          }
          const type_plan = this.propsPlans;
          this.getInformationsPlans(type_plan);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    //Função addons (Users, Chips, Implantacao, ImplantacaoTec)
    hasAddons() {
      this.addons.forEach((element) => {
        this.quantityMensage = element.qty_messagess;
        this.verifyIsPackageMsg(element);
        this.verifyIsChip(element);
        this.verifyTechnicalImplementation(element);
        this.verifyImplementation(element);
        this.couponAddon = element.sale_item.id;
        this.couponId = element.coupon.id;

        this.addonsInformation = element.sale_item.id.split("-", 5);

        //Users
        if (this.addonsInformation[1] === "users") {
          this.usersEnable = true;
          this.extraUsers = this.addonsInformation[2];
          this.usersValueUnit = element.value;
          this.hasUsersCoupon = element.coupon.id;
          //Se tiver a desconto, chama a função para dar desconto no preço e no preço final
          if (this.hasUsersCoupon) {
            this.hasUsersDiscount = true;
            const couponAddon = this.couponAddon;
            const couponId = this.couponId;
            this.getCouponsUsers(couponAddon, couponId);
          } else {
            this.usersValue = this.usersValueUnit;
          }
        }

        const implantacao = this.addonsInformation[1];

        //Implantação
        if (implantacao === "implantacao") {
          this.hasImplementation = true;
          this.implantacaoValueUnit = element.value;
          this.hasImplantacaoCoupon = element.coupon.id;

          if (this.hasImplantacaoCoupon) {
            const couponAddon = this.couponAddon;
            const couponId = this.couponId;
            //Se tiver a desconto, chama a função para dar desconto no preço e no preço final
            this.getCouponsImplantacao(couponAddon, couponId);
          } else {
            this.totalValueService =
              (this.implantacaoTecValueUnit
                ? this.implantacaoTecValueUnit
                : 0) +
              (this.implantacaoValueUnit ? this.implantacaoValueUnit : 0);
          }
        }

        //Implantação Tec
        if (implantacao === "implantacaotec") {
          this.hasImplementationTec = true;
          this.implantacaoTecValueUnit = element.value;
          this.hasImplantacaoTecCoupon = element.coupon.id;

          if (this.hasImplantacaoTecCoupon) {
            this.implamentationDiscount = true;
            const couponAddon = this.couponAddon;
            const couponId = this.couponId;
            //Se tiver a desconto, chama a função para dar desconto no preço e no preço final
            this.getCouponsImplantacaoTec(couponAddon, couponId);
          } else {
            this.totalValueService =
              (this.implantacaoTecValueUnit
                ? this.implantacaoTecValueUnit
                : 0) +
              (this.implantacaoValueUnit ? this.implantacaoValueUnit : 0);
          }
        }

        //Chips
        if (this.addonsInformation[1] === "chips") {
          this.chipEnable = true;
          this.totalValueChips = element.value;
          this.chipsValueUnit = element.value;
          this.chipName = element.sale_item.name;
          this.hasChipsCoupon = element.coupon.id;

          if (this.hasChipsCoupon) {
            this.chipCouponEnable = true;

            const couponAddon = this.couponAddon;
            const couponId = this.couponId;
            //Se tiver a desconto, chama a função para dar desconto no preço e no preço final
            this.getCouponsChip(couponAddon, couponId);
          } else {
            this.chipsValueUnit = element.value;
          }
        }
      });
    },

    verifyIsPackageMsg(value) {
      const msgValue = value.sale_item.id.split("-", 3);
      if (msgValue[1] === "msg") {
        this.hasMessage = true;
        let valueArray = [];
        valueArray.push(value);
        this.packageValues = valueArray[0];
      }
    },

    verifyIsChip(value) {
      const chipName = value.sale_item.id.split("-", 3);
      if (chipName[1] === "chip") {
        this.hasChip = true;
        let valueArray = [];
        valueArray.push(value);
        this.packageChipValues = valueArray[0];
      }
    },

    verifyImplementation(value) {
      const implementation = value.sale_item.id.split("-", 3);
      if (implementation[1] === "implantacao") {
        let valueArray = [];
        valueArray.push(value);
        this.technicalImplementation = valueArray[0];
      }
    },

    verifyTechnicalImplementation(value) {
      const implementation = value.sale_item.id.split("-", 3);
      if (implementation[1] === "implantacaotec") {
        let valueArray = [];
        valueArray.push(value);
        this.technicalImplementationTec = valueArray[0];
      }
    },

    //Informações de Planos
    async getInformationsPlans(type_plan) {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${billingApiUrl()}billingPlans/${type_plan}`,
        headers: {},
      };
      await axios
        .request(config)
        .then((response) => {
          this.planTitle = response.data.name;
          const getTypePlan = response.data.name.split(" ", 3);
          this.planTitle = this.planTitle.replace('TALLOS ', 'RD Station Conversas ')
          this.typePlan = getTypePlan[2];

          //Quantidade de licenças por plano
          this.licensesPlans = response.data.seat_numbers;
          //Valor mensal
          this.total_value_month = this.convertStringToNumber(
            response.data.price
          );
          //Valor anual
          this.total_value_year = this.convertStringToNumber(
            response.data.total_value
          );

          //Plano MENSAL Sem Desconto
          this.priceTotalPlan = this.total_value_month;

          //Plano ANUAL Sem Desconto
          this.valuePlans = this.total_value_year;

        })
        .catch((error) => {
          console.error(error);
        });
    },

    //Valores de cupons para os Usuários
    async getCouponsUsers(couponAddon, couponId) {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${billingApiUrl()}coupon/${couponAddon}/${couponId}`,
        headers: {},
      };

      await axios
        .request(config)
        .then((response) => {
          if (response.data.data.valid === true) {
            this.usersValue =
              this.usersValueUnit * (1 - response.data.data.coupon.value);
            this.userDiscount = response.data.data.coupon.value * 100;
            this.userDiscountNumber = response.data.data.coupon.value;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },

    //Valores de cupons para Implantação
    async getCouponsImplantacao(couponAddon, couponId) {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${billingApiUrl()}coupon/${couponAddon}/${couponId}`,
        headers: {},
      };

      await axios
        .request(config)
        .then((response) => {
          this.descountDisabled = true;
          this.implementacaoValue =
            this.implantacaoValueUnit * (1 - response.data.data.coupon.value);
          this.implementacaoDiscount = response.data.data.coupon.value * 100;
          this.implementacaoDiscountNumber = response.data.data.coupon.value;

          this.totalValueService =
            (this.implementacaoTecValue ? this.implementacaoTecValue : 0) +
            (this.implementacaoValue ? this.implementacaoValue : 0);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    //Valores de cupons para ImplantaçãoTec
    async getCouponsImplantacaoTec(couponAddon, couponId) {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${billingApiUrl()}coupon/${couponAddon}/${couponId}`,
        headers: {},
      };
      await axios
        .request(config)
        .then((response) => {
          this.descountDisabled = true;
          this.implementacaoTecValue =
            this.implantacaoTecValueUnit *
            (1 - response.data.data.coupon.value);

          this.implementacaoDiscount = response.data.data.coupon.value * 100;
          this.implementacaoDiscountNumber = response.data.data.coupon.value;

          //Cálculo Valor Final Serviço com Cupom
          this.totalValueService =
            (this.implementacaoTecValue ? this.implementacaoTecValue : 0) +
            (this.implementacaoValue ? this.implementacaoValue : 0);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    async getCouponsChip(couponAddon, couponId) {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${billingApiUrl()}coupon/${couponAddon}/${couponId}`,
        headers: {},
      };
      await axios
        .request(config)
        .then((response) => {
          this.chipDiscount = response.data.data.coupon.value * 100;
          this.chipDiscountValue = response.data.data.coupon.value;
          this.chipsValueUnit =
          this.chipsValueUnit * (1 - this.chipDiscountValue);
        })

        .catch((error) => {
          console.error(error);
        });
    },

    //Valores de cupons para os Planos
    async getCouponsPlans(codeService, codeCoupons) {
      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${billingApiUrl()}coupon/${codeService}/${codeCoupons}`,
        headers: {},
      };
      await axios
        .request(config)
        .then((response) => {
          const coupon = response.data.data.coupon;
          if (coupon) {
            this.enableDiscount = true;
            this.percetualCalculate    = coupon.value;
            this.percentageCoupon      = Math.round(coupon.value * 100);
            this.valuePlans           *= (1 - this.percetualCalculate);
            this.total_value_month    *= (1 - this.percetualCalculate);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },

    convertStringToNumber(str) {
      let cleanedStr = str.replace("R$", "");
      cleanedStr = cleanedStr.replace(/\./g, "");
      cleanedStr = cleanedStr.replace(",", ".");
      return Number(cleanedStr);
    },

    termsAccepted() {
      const checkValue = document.getElementById("flexCheckDefault").checked;
      if (!checkValue) {
        this.activateButton = true;
        return;
      }
      this.activateButton = false;
    },

    createProposal() {
      this.isLoading = !this.isLoading;
      let data = JSON.stringify(
        {
          id_customer_lead: this.proposal._id,
          isSeller: true,
          name: this.proposal.name,
          legal_name: this.proposal.legal_name,
          person_type: "legal_entity",
          document: this.proposal.document,
          locale: "pt-BR",
          address: {
            street: this.proposal.address.street,
            district: this.proposal.address.district,
            zip_code: this.proposal.address.zip_code,
            number: this.proposal.address.number,
            complement: this.proposal.address.complement,
            city: this.proposal.address.city,
            state: this.proposal.address.state,
            country_code: this.proposal.address.country_code,
            phone: this.proposal.address.phone,
          },
          email: this.proposal.email,
          kind: "admin",
          phone: this.proposal.phone,
          mobile: this.proposal.mobile,
          jobTitle: "Engineer",
          subscription: {
            id_customer: "",
            sale_item: {
              id: this.subscriptios.sale_item.id,
              name: this.subscriptios.sale_item.name,
            },
            billing_config: {
              interval_unit: this.subscriptios.billing_config.interval_unit,
              interval_length: this.subscriptios.billing_config.interval_length,
              quantity: this.subscriptios.billing_config.quantity,
            },
            payment_config: {
              expiration_day: this.expirationDay,
              payment_mode: "manual",
              use_payments_net_term_days: true,
              payments_net_term_days: this.paymentsNetTermDays,
            },
            addon: this.addons,
            coupon: {
              id: this.subscriptios.coupon.id,
            },
            seller_id: parseInt(this.proposal.seller_id),
          },
          focal_point_data: this.focal_point_data,
          sales_channel: this.proposal.sales_channel,

          // eslint-disable-next-line no-prototype-builtins
          manager_partner_id: this.proposal.hasOwnProperty("partner")
            ? this.proposal.partner.id
            : "",
            
          // eslint-disable-next-line no-prototype-builtins
          partner_program: this.proposal.hasOwnProperty("partner_program")
            ? this.proposal.partner_program
            : "",
          
          one_time_credit: this.oneTimeCredit,
        },  

        setTimeout(() => {
          this.isLoading = false;
          this.handleProposalAccepted()
        }, 5000)
      );
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${billingApiUrl()}customer/lead`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios
        .request(config)
        .then(() => {
          this.cancel = true;
          this.activateButton = true;
          this.checketFinish = true;
        })
        .catch((error) => {
          console.error(error);
        })
    },
  },

  computed: {
    userAddonValue() {
      const monthly = this.usersValue || 0;            // valor mensal já com desconto
      const factor  = this.yearOrMonth === "Anual" ? 12 : 1;
      return this.formatBRL(monthly * factor);
    },

    licensesPlans() {
      const planId = this.subscriptios?.sale_item?.id || "";
      
      const plans = ["advanced", "pro", "basic"];
      return plans.some(p => planId.includes(p)) ? "Ilimitado" : "-";
    },
    chipsMonthlyValue() {
      return this.chipsValueUnit || 0;
    },
    totalPriceComputed() {
      const annual = this.yearOrMonth === 'Anual';

      // Plano: mensal vs. anual
      const plan = annual
        ? this.valuePlans            // já veio de total_value_year * cupom
        : this.total_value_month;    // já veio de price * cupom

      // Usuários extras: se anual multiplica por 12
      const users = (this.usersValue || 0) * (annual ? 12 : 1);

      // Chips: idem
      const chips = (this.chipsValueUnit || 0) * (annual ? 12 : 1);

      // Serviço (único) e crédito único
      const svc   = this.totalValueService || 0;
      const oneOff= this.oneTimeCredit     || 0;

      const sum = plan + users + chips + svc + oneOff;
      return this.formatBRLWithoutRS(sum);
    },
   }
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@700&display=swap");

.wrapper {
  max-width: 1280px;
  font-family: "Nunito Sans", sans-serif !important;
  font-size: 16px;
  --primary-color: #11A7B6;
  --checkout-bg-color: #F8F8F8;
  --high-emphasis-color: #212429;
  --low-emphasis-color: #636E7C;
}

h1 {
  font-size: 1.75rem;
  color: var(--high-emphasis-color);
}

h2 {
  font-size: 1.25rem;
  color: var(--low-emphasis-color);
}

.subtitle {
  font-size: 1rem;
  color: var(--primary-color);
}

.information-label {
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--high-emphasis-color);
}

.information-value {
  font-size: 1rem;
  font-weight: 400;
  overflow-wrap: break-word;
  color: var(--low-emphasis-color);
}

.checkout-wrapper {
  padding: 2rem;
  border-radius: 2px;
  background-color: var(--checkout-bg-color);
}

.checkout-label {
  font-size: 1rem;
  color: var(--high-emphasis-color);
}

.checkout-value, .checkout-primary-value {
  margin: 0;
  font-size: 1rem;
  text-align: end;
  color: var(--low-emphasis-color);
}

.checkout-primary-value {
  color: var(--primary-color);
}

.checkout-price {
  margin: 0;
  text-align: end;
  font-weight: 400;
  font-size: 0.75rem;
  color: var(--low-emphasis-color);
}

.checkout-price-value, .checkout-primary-price-value  {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--low-emphasis-color);
}

.checkout-primary-price-value {
  color: var(--primary-color);
}

.text-color-price {
  color: rgb(97, 97, 97);
  font-size: 15px;
}

.btn.button-finish[disabled]{
  background-color: #EEF0F2 !important;
  color: #868C94 !important;
  border: 1px solid #F1F3F5;
}
.single-payment {
  font-size: 13px;
}

.text-info1 {
  font-size: 15px;
  color:#11A7B6;
  font-weight: bolder;
}

.purchase-summary {
  padding: 12px;
  border-radius: 2px;
  border: 1px solid #D5D8DB;
}

.purchase-summary-title {
  color: var(--high-emphasis-color);
}

.text-term {
  font-weight: 400;
  font-size: 0.875rem;
  color: var(--low-emphasis-color);
  display: inline;
  
  > a {
    font-weight: 800;
    text-decoration: none;
    color: var(--primary-color);
  }
}

.resume-buy-box {
  margin: 0;
  font-size: 25px;
}

.line-vertical {
  border-left: 4px solid;
  box-sizing: border-box;
  color: #d6d6d6;
  height: 90%;
  margin-top: 50px;
}

.button-finish{
  background: #19C1CE !important;
  height: auto;
  color: #212429 !important;
}
#buttonAccepted:hover{
  background: #3BE5EB !important;
  color:  #212429;
}

#buttonAccepted, #buttonDeclined {
  font-size: 1rem;
  font-weight: 700;
  padding: .5rem 1rem;
}
#buttonAccepted{
  border: none !important;
  border-radius: 2px !important;
}

.form-check-input:checked {
  background-color: #11A7B6 !important; 
  border-color: #11A7B6;
}

@media screen and (max-width: 1200px) {
  .line-vertical {
    display: none;
  }
}
</style>

